export default __webpack_public_path__ + "static/2-5d5a0c42463e6036d8eca3c3931b9dd4.jpeg";